import React from 'react'
import { FaTemperatureHalf } from "react-icons/fa6";
import { BiTachometer } from "react-icons/bi";
import { FaWind } from "react-icons/fa";
import { CiCloudOn } from "react-icons/ci";
import { WiHumidity } from "react-icons/wi";
import { MdVisibility } from "react-icons/md";
import { FiSunrise, FiSunset } from "react-icons/fi";
import { GiDew } from "react-icons/gi";

const CurrentWeather = ({ weather }) => {
    const pm2_5 = weather.pm2_5;
    console.log(pm2_5);

    // Function to calculate AQI for PM2.5
    function calculateAqi(pm2_5) {
        let aqi;
        let I_hi, I_lo, C_hi, C_lo;

        if (pm2_5 <= 12.0) {
            I_hi = 50; I_lo = 0; C_hi = 12.0; C_lo = 0.0;
        } else if (pm2_5 > 12.1 && pm2_5 <= 35.4) {
            I_hi = 100; I_lo = 51; C_hi = 35.4; C_lo = 12.1;
        } else if (pm2_5 > 35.5 && pm2_5 <= 55.4) {
            I_hi = 150; I_lo = 101; C_hi = 55.4; C_lo = 35.5;
        } else if (pm2_5 > 55.5 && pm2_5 <= 150.4) {
            I_hi = 200; I_lo = 151; C_hi = 150.4; C_lo = 55.5;
        } else if (pm2_5 > 150.5 && pm2_5 <= 250.4) {
            I_hi = 300; I_lo = 201; C_hi = 250.4; C_lo = 150.5;
        } else if (pm2_5 > 250.5 && pm2_5 <= 500.4) {
            I_hi = 500; I_lo = 301; C_hi = 500.4; C_lo = 250.5;
        } else {
            // If the value is outside the provided range, handle accordingly
            return "Value out of range";
        }

        // Calculate the AQI using the formula
        aqi = ((I_hi - I_lo) / (C_hi - C_lo)) * (pm2_5 - C_lo) + I_lo;
        return Math.trunc(aqi);
    }
    // Get the exact AQI for PM2.5
    const aqiValue = calculateAqi(pm2_5);
    let airPollution;

    switch (true) {
        case (aqiValue >= 0 && aqiValue <= 50):
            airPollution = "Good";
            break;
        case (aqiValue >= 51 && aqiValue <= 100):
            airPollution = "Moderate";
            break;
        case (aqiValue >= 101 && aqiValue <= 150):
            airPollution = "Poor";
            break;
        case (aqiValue >= 151 && aqiValue <= 200):
            airPollution = "Unhealthy";
            break;
        case (aqiValue >= 201 && aqiValue <= 300):
            airPollution = "Very Unhealthy";
            break;
        case (aqiValue >= 301):
            airPollution = "Hazardous";
            break;
        default:
            airPollution = "";
            break;
    }

    return (
        <>
            <div className="current-weather">
                <h1 className='text-center text-white/[0.9] text-[22px] uppercase font-bold mb-1'>current weather</h1>
                <div className="flex justify-between items-center px-2 sm:px-3 py-3 bg-white/[0.3] rounded backdrop-blur-sm">
                    <div className="location text-center">
                        <h2 className='text-white uppercase text-[18px] font-bold'>{weather.name}, {weather.country}</h2>
                        <h3 className='text-white/[0.8] text-[15px] font-[600]' >{weather.date}</h3>
                        <h4 className='text-white/[0.8] text-[15px] font-[600]' id='time'>{weather.time}</h4>
                    </div>
                    <div className="temprature text-center">
                        <h1 className='text-white font-bold text-2xl'> {`${weather.temp.toFixed()}°C`}</h1>
                        <p className='font-[600] text-white/[0.8] text-[15px] capitalize'>{weather.description}</p>
                    </div>
                    <div className="image">
                        <img src={weather.iconURL} alt="" />
                    </div>
                </div>
            </div>

            <div className="weather-details mt-2">
                <div className="grid grid-cols-3 sm:grid-cols-4 gap-3 px-2 sm:px-0 py-2 bg-white/[0.3] rounded all columns-4 backdrop-blur-sm">
                    <div className="real-feel text-center">
                        <p className='font-semibold text-[16px] text-white/[0.6]'><span className='pe-1 text-[20px]'><FaTemperatureHalf /></span>Real Feel</p>
                        <h5 className='text-white font-bold text-[18px]'>{`${weather.feels_like.toFixed()}°C`}</h5>
                    </div>
                    <div className="wind">
                        <p className='font-semibold text-[16px] text-white/[0.6]'><span className='pe-1 text-[20px]'><FaWind /></span>Wind</p>
                        <h5 className='text-white font-bold text-[18px]'>{`${weather.speed} KM/H`}</h5>
                    </div>
                    <div className="cloud">
                        <p className='font-semibold text-[16px] text-white/[0.6]'><span className='pe-1 text-[20px]'><CiCloudOn /></span>Clouds</p>
                        <h5 className='text-white font-bold text-[18px]' id='cloud'>{`${weather.clouds}%`}</h5>
                    </div>
                    <div className="humidity">
                        <p className='font-semibold text-[16px] text-white/[0.6]'><span className='pe-1 text-[20px]'><WiHumidity /></span>Humidity</p>
                        <h5 className='text-white font-bold text-[18px]'>{`${weather.humidity}%`}</h5>
                    </div>
                    <div className="rain">
                        <p className='font-semibold text-[16px] text-white/[0.6]'><span className='pe-1 text-[20px]'><BiTachometer /></span>Pressure</p>
                        <h5 className='text-white font-bold text-[18px]'>{`${weather.pressure}hPa`}</h5>
                    </div>
                    <div className="visibility">
                        <p className='font-semibold text-[16px] text-white/[0.6]'><span className='pe-1 text-[20px]'><MdVisibility /></span>Visibility</p>
                        <h5 className='text-white font-bold text-[18px]'>{`${weather.visibility / 1000} KM`}</h5>
                    </div>
                    <div className="sunrise">
                        <p className='font-semibold text-[16px] text-white/[0.6]'><span className='pe-1 text-[20px]'><FiSunrise /></span>Sunrise</p>
                        <h5 className='text-white font-bold text-[18px]'>{weather.Sunrise}</h5>
                    </div>
                    <div className="sunset">
                        <p className='font-semibold text-[16px] text-white/[0.6]'><span className='pe-1 text-[20px]'><FiSunset /></span>Sunset</p>
                        <h5 className='text-white font-bold text-[18px]'>{weather.Sunset}</h5>
                    </div>
                    <div className="dew-point">
                        <p className='font-semibold text-[16px] text-white/[0.6]'><span className='pe-1 text-[20px]'><GiDew /></span>Dew</p>
                        <h5 className='text-white font-bold text-[18px]'>{`${weather.dew_point.toFixed(1)}%`}</h5>
                    </div>

                    <div className="aqi">
                        <p className='font-semibold text-[16px] text-white/[0.6]'><span className='pe-1 text-[20px]'><GiDew /></span>Air Quality</p>
                        <h5 className='text-white font-bold text-[18px] d'><span className={`w-4 h-4 rounded-lg inline-block me-1 ${airPollution}`}></span>{`${aqiValue}`}</h5>
                    </div>

                    <div className="air polution">
                        <p className='font-semibold text-[16px] text-white/[0.6]'><span className='pe-1 text-[20px]'><FaWind /></span>Air Polution</p>
                        <h5 className='text-white font-bold text-[18px]'> {airPollution}</h5>
                    </div>
                </div>
            </div>
        </>
    )
}

export default CurrentWeather
